import { useEffect, useState } from 'react';
import {
  AuthorizedAgentType,
  CountriesType,
  RequestDefinition,
  RequestorTypesGetType,
  requestService,
} from '../../../services';
import { userProfileService } from '../../../services/userprofile/userProfileService';
import { UserProfile } from '../../../services/userprofile/types';
import { LanguageContainer } from '../../../state/languageContainer';
import { defaultAuthorizedAgentData } from '../config';
import { ErrorCodes } from '../../../constants/errorCodes';
import { RedirectUrls } from '../../../constants/routes';
import { useNavigate } from 'react-router-dom';
import { TenantContainer } from '../../../state/tenantContainer';

export const useSubmitRequest = ({ publishName, token, employeeToken, integrationName, idToken, formToken }: any) => {
  const [countries, setCountries] = useState<CountriesType[]>([]);
  const [userProfiles, setUserProfiles] = useState<UserProfile[]>([]);
  const [requestorTypes, setRequestorTypes] = useState<RequestorTypesGetType>();
  const [requestDefinitions, setRequestDefinitions] = useState<RequestDefinition[]>([]);
  const [authorizedAgent, setAuthorizedAgent] = useState<AuthorizedAgentType>(defaultAuthorizedAgentData);
  const { tenant } = TenantContainer.useContainer();
  const navigate = useNavigate();
  const { language } = LanguageContainer.useContainer();

  useEffect(() => {
    if (!language) {
      return;
    }

    requestService
      .getSelectCounties(language)
      .then(resp => {
        setCountries(resp.countries);
      })
      .catch(err => console.log('Todo:', err));
  }, [language]);

  useEffect(() => {
    userProfileService
      .getProfiles(publishName)
      .then(resp => {
        setUserProfiles(resp.profiles);
      })
      .catch(err => console.log('Todo:', err));
  }, [publishName]);

  useEffect(() => {
    if (!language) {
      return;
    }

    requestService
      .getRequestFormByPublishName({ publishName, language, token, employeeToken, integrationName, idToken, formToken })
      .then(({ requestorTypes, flows, brandAuthorizedAgent }) => {
        setRequestorTypes(requestorTypes);
        setRequestDefinitions(flows);
        setAuthorizedAgent(brandAuthorizedAgent);
      })
      .catch(err => {
        switch (err?.response?.data?.errorCode) {
          case ErrorCodes.SESSION_EXPIRED:
            navigate(`/${tenant.tenantId}${RedirectUrls.ERROR}${RedirectUrls.SESSION_EXPIRED}`);
            break;
          default:
            console.log('Todo:', err);
        }
      });
  }, [publishName, language, token, employeeToken, integrationName, idToken, formToken]);

  return {
    countries,
    userProfiles,
    requestorTypes,
    requestDefinitions,
    authorizedAgent,
  };
};
